/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraThreatsTrendListFiltersSortCriteria {
    getFixupPrototypeFunction() { return InfraThreatsTrendListFiltersSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<InfraThreatsTrendListFiltersSortCriteria>): InfraThreatsTrendListFiltersSortCriteria {
        let obj = Object.assign(new InfraThreatsTrendListFiltersSortCriteria(), model);
        InfraThreatsTrendListFiltersSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraThreatsTrendListFiltersSortCriteria>): InfraThreatsTrendListFiltersSortCriteria {
        if (!model) return null;
        return InfraThreatsTrendListFiltersSortCriteria.newInstance(<InfraThreatsTrendListFiltersSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraThreatsTrendListFiltersSortCriteria) {
        if (!obj) return;

        models.InfraThreatsTrendListFiltersSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraThreatsTrendListFiltersSortCriteria): boolean {
        Object.setPrototypeOf(obj, InfraThreatsTrendListFiltersSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.InfraThreatsTrendListFiltersSortColumn;

    ascending: boolean;

}
